import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { BookOpen, ChevronRight, ArrowLeft } from "lucide-react";

export default function Playbooks() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => { api.get("/success/playbooks").then(r => setItems(r.data.items || [])); }, []);

  if (selected) {
    return (
      <div className="max-w-3xl">
        <button onClick={() => setSelected(null)} className="text-sm text-slate-500 hover:text-navy inline-flex items-center gap-1 mb-4">
          <ArrowLeft className="w-4 h-4" /> All playbooks
        </button>
        <div className="eyebrow mb-2">Playbook</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-navy">{selected.title}</h1>
        <p className="text-slate-600 mt-2">{selected.summary}</p>
        <div className="mt-8 space-y-6">
          {selected.steps.map((s, i) => (
            <div key={i} className="border border-slate-200 rounded-xl bg-white p-6 card-lift">
              <div className="flex items-start gap-4">
                <div className="h-9 w-9 rounded-full bg-navy text-white grid place-items-center font-display font-semibold flex-shrink-0">{i+1}</div>
                <div>
                  <div className="font-display text-lg font-semibold text-navy">{s.heading}</div>
                  <p className="text-slate-600 mt-1 leading-relaxed">{s.body}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-6">
        <div className="eyebrow mb-2">Success Center</div>
        <h1 className="font-display text-3xl font-bold text-navy">Recruiting Playbooks</h1>
        <p className="text-sm text-slate-500 mt-1">Step-by-step guides for every part of the recruiting cycle.</p>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {items.map(p => (
          <button key={p.slug} onClick={() => setSelected(p)}
            className="card-lift border border-slate-200 rounded-xl bg-white p-5 text-left">
            <div className="h-10 w-10 rounded-lg bg-gold/10 text-gold grid place-items-center mb-3">
              <BookOpen className="w-5 h-5" />
            </div>
            <div className="font-display text-lg font-semibold text-navy">{p.title}</div>
            <p className="text-sm text-slate-600 mt-1">{p.summary}</p>
            <div className="mt-3 text-xs text-navy inline-flex items-center gap-1 font-medium">
              {p.steps.length} steps <ChevronRight className="w-3.5 h-3.5" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
